export default "__VITE_ASSET__B6x2RQAu__"